<template>
  <!-- ******** Inicio Card Principal ******** -->
  <v-container text-xs-center>
    <div class="swiper-container mt-3 animated fadeIn delay-1s">
      <div class="swiper-wrapper timeline">
        <div class="swiper-slide" v-for="(item, index) in timeline" :key="index">
          <div class="timestamp">
            <span class="date">{{ item.title }}</span>
          </div>
          <div class="status">
            <span>{{ item.dateLabel }}</span>
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <h5 class="text-uppercase text-xs-left ml-2 mt-2 animated fadeIn delay-1s">
      Resumo de Atividades
    </h5>
    <v-card class="animated fadeIn delay-1s">
      <v-layout row wrap mt-2 justify-center>
        <v-flex xs6 mt-3>
          <v-icon medium color="#099AB1">fa-shopping-bag</v-icon>
          <br />
          <span>Vendas Realizadas</span>
          <p>
            <strong>{{ this.vendasRealizadas }}</strong>
          </p>
        </v-flex>

        <v-flex xs6 mt-3>
          <v-icon medium color="#099AB1">fas fa-cart-arrow-down</v-icon>
          <br />
          <span>Quantidade de Peças</span>
          <p>
            <strong>{{ this.vendasPdv }}</strong>
          </p>
        </v-flex>

        <v-flex xs6>
          <v-badge color="white" right>
            <template v-slot:badge>
              <v-icon dark small color="#4CAF50">done</v-icon>
            </template>
            <v-icon large color="#099AB1">fa-street-view</v-icon>
          </v-badge>
          <br />
          <span>Novos Clientes</span>
          <p>
            <strong>{{ this.clientesNovos }}</strong>
          </p>
        </v-flex>

        <v-flex xs6>
          <v-badge color="white" right>
            <template v-slot:badge>
              <v-icon dark small color="#FF9800">star</v-icon>
            </template>
            <v-icon large color="#099AB1">fa-street-view</v-icon>
          </v-badge>
          <br />
          <span>Clientes de Recompra</span>
          <p>
            <strong>{{ this.clientesRecompra }}</strong>
          </p>
        </v-flex>

        <v-flex xs6>
          <v-icon medium color="#099AB1">mdi-bullseye-arrow</v-icon>
          <br />
          <span>Campanhas Realizadas</span>
          <p>
            <strong>{{ this.campanhasRealizadas }}</strong>
          </p>
        </v-flex>

        <v-flex xs6>
          <v-icon medium color="#099AB1">fa-envelope</v-icon>
          <br />
          <span>Mensagens Enviadas</span>
          <p>
            <strong>{{ this.mensagensEnviadas }}</strong>
          </p>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- ******** Fim Card Principal ******** -->

    <!-- ******** Inicio Card Secundario ******** -->
    <div class="marginToBottom">
      <h5 class="text-uppercase text-xs-left mt-2 ml-2 animated fadeIn delay-2s">
        SITUAÇÃO DE CLIENTES
      </h5>
      <v-card
        class="animated fadeIn delay-1s"
        style="
    margin-bottom: 60px;"
      >
        <v-layout row wrap mt-3>
          <v-flex xs12>
            <v-icon medium color="#099AB1">fa-users</v-icon>
            <br />
            <span>Base de Clientes</span>
            <p>
              <strong>{{ this.baseClientes }}</strong>
            </p>
          </v-flex>
        </v-layout>

        <v-layout row justify-center pr-4 pl-4>
          <div style="min-width: 7%"
            :style="
              `width:${((this.baseClientes == 0 ? 1 : this.clientesAtivos) / this.baseClientes) *
                0.95 *
                100}%`
            "
          >
            <v-card tile color="#95d097" class="white--text ativos-graph">
              <strong>{{ ((this.clientesAtivos / this.baseClientes) * 0.95) | toPercent }}%</strong>
            </v-card>
          </div>

          <div style="min-width: 7%"
            :style="
              `width:${((this.baseClientes == 0 ? 1 : this.clientesRisco) / this.baseClientes) *
                0.95 *
                100}%`
            "
          >
            <v-card tile color="#ffc266" class="white--text risco-graph">
              <strong>{{ (this.clientesRisco / this.baseClientes) | toPercent }}%</strong>
            </v-card>
          </div>

          <div style="min-width: 7%"
            :style="
              `width:${((this.baseClientes == 0 ? 1 : this.clientesInativos) / this.baseClientes) *
                0.95 *
                100}%`
            "
          >
            <v-card tile color="#f7776e" class="white--text inativos-graph">
              <strong>{{ (this.clientesInativos / this.baseClientes) | toPercent }}%</strong>
            </v-card>
          </div>

          <div style="min-width: 7%"
            :style="
              `width:${((this.baseClientes == 0 ? 1 : this.clientesPerdidos) / this.baseClientes) *
                0.95 *
                100}%`

            "
          >
            <v-card tile color="#CDCDCD" class="white--text perdidos-graph">
              <strong >{{ (this.clientesPerdidos / this.baseClientes) | toPercent }}%</strong>
            </v-card>
          </div>
        </v-layout>

        <v-layout row justify-center mt-2>
          <v-flex xs3 mb-3>
            <span class="ativos"
              ><v-icon color="#95d097" small left>fiber_manual_record</v-icon>Ativos</span
            >
          </v-flex>

          <v-flex xs3>
            <span class="risco"
              ><v-icon color="#ffc266" small left>fiber_manual_record</v-icon>Risco</span
            >
          </v-flex>

          <v-flex xs3>
            <span class="inativos"
              ><v-icon color="#f7776e" small left>fiber_manual_record</v-icon>Inativos</span
            >
          </v-flex>

          <v-flex xs3>
            <span class="perdidos"
              ><v-icon color="#CDCDCD" small left>fiber_manual_record</v-icon>Perdidos</span
            >
          </v-flex>
        </v-layout>
      </v-card>
    </div>
    <!-- ******** Fim Card Secundario ******** -->

    <!-- ******** Inicio Header Terceiro Card ******** -->
    <!-- <h5 class="text-uppercase text-xs-left ml-2 mt-2">Resultado de Campanhas</h5> -->
    <!-- ******** Fim Header Terceiro Card ******** -->

    <!-- ******** Inicio Content Terceiro Card ******** -->
    <!-- <v-card class="mb-2" v-for="campanha in campanhas" :key="campanha.id">
      <v-layout row wrap >
        <v-expansion-panel >
          <v-expansion-panel-content >
            <template v-slot:header>
              <v-layout row wrap>
                <v-flex xs8>
                  <span class="text-xs-left ma-2">
                    <v-icon small>fas fa-bullseye</v-icon>
                    {{campanha.name}}
                  </span>
                </v-flex>

                <v-flex xs4>
                  <span>{{campanha.criacao | filtraData}}</span>
                </v-flex>
              </v-layout>
            </template>
            <v-flex xs12>
              <span>{{campanha.totalEarnings}}</span>
            </v-flex>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-layout>
    </v-card> -->
    <!-- ******** Fim Content Terceiro Card ******** -->
  </v-container>
</template>

<script>
import {
  format, subMonths, startOfMonth, endOfMonth,
} from 'date-fns';
import { APIService } from '@/resources/indicadores.js';

const ptLocale = require('date-fns/locale/pt');

const api = new APIService();

let swiper;

export default {
  filters: {
    toPercent: (result) => {
      const perc = Math.floor(result * 100);
      if (isNaN(perc)) {
        return 0;
      }
      return perc;
    },
    filtraData(value) {
      if (value) {
        return format(value, 'DD/MM/YYYY');
      }
    },
  },
  mounted() {
    this.getVendasPdv(this.dataInicio, this.dataFim);
    this.getClientesNovos(this.dataInicio, this.dataFim);
    this.getClientesRecompra(this.dataInicio, this.dataFim);
    this.getCampanhaStats(this.dataInicio, this.dataFim);
    this.getClientesPorVendedor();
    this.getLastYear();

    swiper = new Swiper('.swiper-container', {
      init: false,
      grabCursor: true,
      paginationClickable: true,
      nextButton: '.next-slide',
      prevButton: '.prev-slide',
      slidesPerView: 5,
      slideToClickedSlide: true,
      iOSEdgeSwipeDetection: true,
      watchOverflow: true,
      centeredSlides: true,
      // slideToClickedSlide: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      initialSlide: 11,
    });

    swiper.on('init', (e) => {
      if (!e || !e.activeIndex) return;
      this.getVendasPdv(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesNovos(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesRecompra(
        this.timeline[e.activeIndex].inicio,
        this.timeline[e.activeIndex].fim,
      );
      this.getCampanhaStats(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesPorVendedor();
    });
    swiper.init();

    swiper.on('transitionEnd', (e) => {
      if (!e || !e.activeIndex) return;
      this.getVendasPdv(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesNovos(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesRecompra(
        this.timeline[e.activeIndex].inicio,
        this.timeline[e.activeIndex].fim,
      );
      this.getCampanhaStats(this.timeline[e.activeIndex].inicio, this.timeline[e.activeIndex].fim);
      this.getClientesPorVendedor();
    });

    swiper.on('transitionStart', (e) => {
      this.vendasPdv = '';
      this.vendasRealizadas = '--';
      this.clientesNovos = '--';
      this.clientesRecompra = '--';
      this.mensagensEnviadas = '--';
      this.campanhasRealizadas = '--';
    });
  },
  methods: {
    getVendasPdv(dataInicio, dataFim) {
      if (!dataInicio || !dataFim) return;
      api.getCustomer(this.$auth.user.sub).then((response) => {
        const seller = response.stores
          .map(s => s.sellers)
          .reduce((a, b) => a.concat(b), [])
          .find(s => s.id == this.$auth.user.sub);
        api.getVendasPdvByVendedor(response.id, seller.name, dataInicio, dataFim).then((data) => {
          if (data.length > 0) {
            this.vendasRealizadas = data[0].count;
            this.vendasPdv = data[0].totalProdutos;
          }
        });
      });
    },
    getClientesNovos(dataInicio, dataFim) {
      if (!dataInicio || !dataFim) return;
      api.getCustomer(this.$auth.user.sub).then((response) => {
        const seller = response.stores
          .map(s => s.sellers)
          .reduce((a, b) => a.concat(b), [])
          .find(s => s.id == this.$auth.user.sub);
        api.getClientesNovos(response.id, seller.name, dataInicio, dataFim).then((data) => {
          if (data.length > 0) this.clientesNovos = data[0].count;
        });
      });
    },
    getClientesRecompra(dataInicio, dataFim) {
      if (!dataInicio || !dataFim) return;
      api.getCustomer(this.$auth.user.sub).then((response) => {
        const seller = response.stores
          .map(s => s.sellers)
          .reduce((a, b) => a.concat(b))
          .find(s => s.id == this.$auth.user.sub);
        api.getClientesRecompra(response.id, seller.name, dataInicio, dataFim).then((data) => {
          if (data.length > 0) this.clientesRecompra = data[0].count;
        });
      });
    },
    async getCampanhaStats(dataInicio, dataFim) {
      if (!dataInicio || !dataFim) return;
      const customer = await api.getCustomer(this.$auth.user.sub);
      const seller = customer.stores
        .map(s => s.sellers)
        .reduce((a, b) => a.concat(b), [])
        .find(s => s.id == this.$auth.user.sub);

      const stats = await api.getCampanhaStats(customer.id, seller.name, dataInicio, dataFim);

      this.campanhasRealizadas = stats.length;
      this.mensagensEnviadas = stats.map(d => d.sent).reduce((a, b) => a + b, 0);

      this.campanhas = await Promise.all(
        stats.map(async el => await api.getCampaign(el._id.campaignId.$id)),
      );
    },
    getClientesPorVendedor() {
      api.getCustomer(this.$auth.user.sub).then((response) => {
        const seller = response.stores
          .map(s => s.sellers)
          .reduce((a, b) => a.concat(b))
          .find(s => s.id == this.$auth.user.sub);
        api.getClientesPorVendedor(response.id, seller.name).then((data) => {
          this.baseClientes = data
            .filter(d => ['ATIVO', 'RISCO', 'INATIVO', 'PERDIDO'].indexOf(d._id.situacao) > -1)
            .map(d => d.count)
            .reduce((a, b) => a + b, 0);
          const atv = data.filter(d => d._id.situacao === 'ATIVO');
          const ris = data.filter(d => d._id.situacao === 'RISCO');
          const ina = data.filter(d => d._id.situacao === 'INATIVO');
          const per = data.filter(d => d._id.situacao === 'PERDIDO');

          this.clientesAtivos = atv.length > 0 ? atv.map(d => d.count).reduce((a, b) => a + b, 0) : 0;
          this.clientesRisco = ris.length > 0 ? ris.map(d => d.count).reduce((a, b) => a + b, 0) : 0;
          this.clientesInativos = ina.length > 0 ? ina.map(d => d.count).reduce((a, b) => a + b, 0) : 0;
          this.clientesPerdidos = per.length > 0 ? per.map(d => d.count).reduce((a, b) => a + b, 0) : 0;
        });
      });
    },
    getLastYear() {
      for (let i = 0; i < 12; i++) {
        const dataInicio = `${format(
          startOfMonth(subMonths(new Date(), i)),
          'YYYY-MM-DD',
        )}T00:00:00.000Z`;
        const dataFim = `${format(
          endOfMonth(subMonths(new Date(), i)),
          'YYYY-MM-DD',
        )}T23:59:59.999Z`;
        const mesLabel = format(startOfMonth(subMonths(new Date(), i)), 'MMM/YY', {
          locale: ptLocale,
        });

        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.timeline.push({
          inicio: dataInicio,
          fim: dataFim,
          dateLabel: mesLabel,
          title: '',
        });
      }
      this.timeline.reverse();
    },
  },
  updated() {
    swiper.update();
    swiper.slideTo(swiper.activeIndex, 0, false);
  },

  data() {
    return {
      vendasRealizadas: '--',
      vendasPdv: '',
      clientesNovos: '--',
      clientesRecompra: '--',
      campanhasRealizadas: '--',
      mensagensEnviadas: '--',
      baseClientes: 0,
      clientesRisco: 0,
      clientesAtivos: 0,
      clientesInativos: 0,
      clientesPerdidos: 0,
      dataInicio: null,
      dataFim: null,
      timeline: [],
      campanhas: [],
    };
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}

.v-expansion-panel__header {
  padding-bottom: 12px !important;
}

.ativos-graph {
  border-radius: 10px 0px 0px 10px;
}

.risco-graph {
  border-radius: 0px 0px 0px 0px;
}

.inativos-graph {
  border-radius: 0px 0px 0px 0px;
}

.perdidos-graph {
  border-radius: 0px 10px 10px 0px;
}
</style>

<style>
body {
  background: #e8eeff;
}
.marginToBottom {
  margin-bottom: 175px;
}

.timeline {
  margin: 0;
  list-style-type: none;
  display: flex;
  padding: 0;
  text-align: center;
}
.timeline li {
  transition: all 200ms ease-in;
}
.timestamp {
  width: 200px;
  margin-bottom: 20px;
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 100;
}
.status {
  padding: 0px 40px;
  display: flex;
  justify-content: center;
  border-top: 2px solid #099ab1;
  position: relative;
  transition: all 200ms ease-in;
}

.status span {
  font-size: 14px;
  padding-top: 20px;
}
.status span:before {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #e8eeff;
  border-radius: 25px;
  border: 2px solid #099ab1;
  position: absolute;
  top: -15px;
  left: 38%;
  transition: all 200ms ease-in;
}
.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  height: 80px;
  margin: 0;
  overflow: hidden;
  padding: 0px 0px 0px 0px;
}
.swiper-slide {
  width: 100%;
  text-align: center;
  font-size: 16px;
}
.swiper-slide:nth-child(2n) {
  width: 40%;
}
.swiper-slide:nth-child(3n) {
  width: 20%;
}

.swiper-slide-active > div > span::before {
  background-color: #099ab1;
}

.swiper-slide-active > div > span {
  font-weight: 600;
}
</style>
